import { useEffect, useState } from "react";
import "../assets/styles/components/profile-panel.scss";
import Exit from "../assets/icons/exit";
import Shop from "../assets/icons/shop";
import { NavLink } from "react-router-dom";
import Profile from "../assets/icons/profile";
import UserRounded from "../assets/icons/user-rounded";

export default function ProfilePanel({
  context,
  closeProfilePanel
}) {
  const [close_menu_effect, setCloseMenuEffect] = useState("");

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handleCloseMenu = () => {
    setCloseMenuEffect("close-effect");
    setTimeout(() => {
      document.body.style.overflow = "auto";
      closeProfilePanel();
    }, 500);
  };

  const handleLogOut = () => {
    
    handleCloseMenu();    
    context.handleLogOut(context);
  };

  return (
    <div
      className={`profile-panel position-fixed w-100 h-100 py-4 d-flex justify-content-center align-items-center ${close_menu_effect}`}
    >
      <div
        onClick={() => handleCloseMenu()}
        className="profile-panel__overlay position-fixed top-0 start-0 h-100 w-100"
      ></div>
      <div className="profile-panel__content shadow-lg position-fixed overflow-auto">
        {context.session ? (
          <div className="profile-info d-flex flex-column align-items-center border-bottom">
            <UserRounded size={50} color="#20419a" />
            <small className="mt-2 mb-1">
              {`${context.session.firstName} ${context.session.lastName}`}
            </small>
            <small className="email">{context.session.email}</small>
          </div>
        ) : null}
        {context.session?.profileTypeCode === "GESTORE" &&
        context.pv_list &&
        context.pv_list.length > 0 ? (
          <div className="pv-list d-flex flex-column border-bottom pb-4">
            <div className="d-flex gap-2 align-items-center px-3 pb-3">
              <Shop size={24} color="#20419a" />
              <span className="fw-bold">Punti vendita associati</span>
            </div>

            <div className="d-flex flex-wrap gap-2 px-3">
              {context.pv_list.map((item, index) => {
                return (
                  <small
                    key={index}
                    title={item.indirizzo}
                    className="pv-item px-2 py-1"
                  >
                    {item.codicePv}
                  </small>
                );
              })}
            </div>
          </div>
        ) : null}

        <NavLink
          onClick={() => handleCloseMenu()}
          to="/account"
          className="px-3 py-3 d-flex align-items-center border-bottom"
        >
          <span className="me-auto">Vai al profilo</span>
          <Profile size={27} color="#858597" className="ms-auto" />
        </NavLink>
        <div
          className="d-flex align-items-center px-3"
          onClick={() => handleLogOut()}
        >
          <span>Log Out</span>
          <Exit size={27} color="#858597" className="ms-auto" />
        </div>
      </div>
    </div>
  );
}
